import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {MenufilterPipe} from "./pipes/menufilter.pipe";
import {RoundoffPipe} from "./pipes/roundoff.pipe";


//import { MaterialModule } from '../app.module';

@NgModule({
  declarations: [MenufilterPipe, RoundoffPipe],
  imports: [
    CommonModule,

  ],
  exports:[MenufilterPipe, RoundoffPipe]
})
export class SharedModule { }
